import axios from 'axios';
import { getApiClientFront, getApiClientBack } from "../api/api";


// const apiUrlMap = {
//   // "pruebabopiweb.oepm.es": "http://pruebaconsultas5.oepm.es:5000",
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/apibopiweb",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",

//   "defaultApiUrl": "Error",
//   "localhost": "http://localhost:5000",    
// };

// const api = axios.create({
//   //  baseURL: "http://localhost:8080/BopiWeb/"    
//   baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
// })

export const generarSuscripcion = async (
  tipoPersona,
  razon,
  correo,
  nombre,
  apellidos,
  cargo,
  selectedSuscripciones
) => {
  const api = await getApiClientBack();
  try {
    const response = await api.post("/suscripciones", {
      tipoIdentificador: tipoPersona,
      razon: razon,
      correo: correo,
      nombre: nombre,
      apellidos: apellidos,
      cargo: cargo,
      tipoSuscripcion: selectedSuscripciones,
    });
    return response.data;
  } catch (error) {
    console.error("Error al generar suscripción:", error.response.data.message);
    throw new Error(error.response.data.message);
  }
};

// // --> PRUEBA API REST (descomentar esto y comentar el equivalente de arriba):
// export const api = axios.create({
//   baseURL: "http://localhost:8080",
// });

// export const generarSuscripcion = async () => {
//   try {
//     const response = await api.get("/BopiWeb/paginascsv/cargar", { });
//     return response.data;
//   } catch (error) {
//     console.error("Error al generar suscripción:", error);
//     throw error;
//   }
// };
// // FIN PRUEBA API REST  <--

export const eliminarSuscripcion = async (correo) => {
  try {
    const api = await getApiClientBack();
    const response = await api.delete(`/suscripciones/baja/${correo}`);
    return response.data;    

  } catch (error) {    
    console.error("Error al generar eliminar suscripción:", error);
    throw new Error(error.response.data.message);

  }
};

